module.exports = __webpack_public_path__ + "img/2.86b23a62.png";